<script lang="ts" setup>
import { computed } from 'vue'
import { BadgeVariant } from './types'

interface Props {
  variant?: keyof typeof BadgeVariant
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: BadgeVariant.default,
})

const badgeClass = computed((): string[] => {
  let cls = [
    'inline-flex',
    'items-center',
    'gap-1',
    'md:gap-1.5',
    'rounded',
    'leading-tight',
    'px-1',
    'py-0.5',
    'border',
    'border-black/10',
    'text-gray-800',
    'antialised',
  ]

  if (props.disabled)
    cls = cls.concat(['opacity-[.43]', 'select-none'])

  switch (props.variant) {
    case BadgeVariant.red:
      cls = cls.concat(['bg-[#FDF2F4]'])
      break
    case BadgeVariant.green:
      cls = cls.concat(['bg-[#E8F8EE]'])
      break
    case BadgeVariant.blue:
      cls = cls.concat(['bg-[#E4EBFD]'])
      break
    case BadgeVariant['light-blue']:
      cls = cls.concat(['bg-[#E2F5FC]'])
      break
    case BadgeVariant.yellow:
      cls = cls.concat(['bg-[#FDF8E4]'])
      break
    case BadgeVariant.purple:
      cls = cls.concat(['bg-[#F2EEFC]'])
      break
    case BadgeVariant.pink:
      cls = cls.concat(['bg-[#FDF3FA]'])
      break
    case BadgeVariant.orange:
      cls = cls.concat(['bg-[#FDEEE7]'])
      break
    case BadgeVariant.lilac:
      cls = cls.concat(['bg-[#F7EEFB]'])
      break
    case BadgeVariant.default:
    default:
      cls = cls.concat(['bg-gray-200'])
      break
  }

  return cls
})
</script>

<template>
  <span :class="badgeClass">
    <slot />
  </span>
</template>
